import {RequestResult, RequestResultValue} from "../../common/api/requestResult";
import {HttpService} from "../../common/api/httpService";
import {PaginationResponse} from "../../models/paginationResponse";
import {AccessBlacklistRow, AccessBlacklistType} from "../../models/accessBlacklist";

export async function accessBlacklistListApi(
    page: number,
    count: number,
    type?: number,
    value?: string
): Promise<RequestResultValue<PaginationResponse<AccessBlacklistRow>>> {
    const result = await HttpService.getInstance().adminFetch(
        `AccessBlacklist/list`,
        "POST",
        {
            page,
            count,
            type: typeof type !== "undefined" ? type : null,
            value: value || null,
            includeDeleted: false,
        }
    );
    if (result.result) {
        return new RequestResultValue<PaginationResponse<AccessBlacklistRow>>(
            true,
            result.value as PaginationResponse<AccessBlacklistRow>
        );
    }
    return new RequestResultValue<PaginationResponse<AccessBlacklistRow>>(false);
}

export async function accessBlacklistAddApi(
    type: number,
    value: string,
    reason: string,
    expiresAt?: string | null
): Promise<RequestResultValue<AccessBlacklistRow>> {
    const result = await HttpService.getInstance().adminFetch(
        `AccessBlacklist/add`,
        "POST",
        { type, value, reason, expiresAt: expiresAt || null }
    );
    if (result.result) {
        return new RequestResultValue<AccessBlacklistRow>(true, result.value as AccessBlacklistRow);
    }
    return new RequestResultValue<AccessBlacklistRow>(false);
}

export async function accessBlacklistRemoveApi(id: number): Promise<RequestResult> {
    const result = await HttpService.getInstance().adminFetch(
        `AccessBlacklist/remove`,
        "POST",
        { id }
    );
    return new RequestResult(result.result);
}

export async function accessBlacklistGetUserApi(
    userId: bigint
): Promise<RequestResultValue<AccessBlacklistRow | null>> {
    const result = await HttpService.getInstance().adminFetch(
        `AccessBlacklist/user/${userId.toString()}`,
        "GET"
    );
    if (!result.result) {
        return new RequestResultValue<AccessBlacklistRow | null>(false);
    }
    return new RequestResultValue<AccessBlacklistRow | null>(true, (result.value as AccessBlacklistRow) ?? null);
}

export async function accessBlacklistRemoveUserApi(userId: bigint): Promise<RequestResult> {
    const result = await HttpService.getInstance().adminFetch(
        `AccessBlacklist/remove-user`,
        "POST",
        { userId }
    );
    return new RequestResult(result.result);
}
